import type { ReactElement, ReactNode } from "react";

import type { IconName } from "@similarweb/icons";
import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

interface IProps {
    title: string;
    iconName?: IconName;
    children: ReactNode;
}

const TopCompanyInfoWrapper = ({ title, iconName, children }: IProps): ReactElement => {
    return (
        <Stack
            gap="4px"
            height="100%"
        >
            <Flex
                alignItems="center"
                gap="4px"
            >
                {iconName ? (
                    <SWReactIcons
                        iconColor={colorsPalettes.carbon[200]}
                        iconName={iconName}
                        size="xs"
                    />
                ) : null}

                <Text
                    fontVariant="caption"
                    color={colorsPalettes.carbon[250]}
                >
                    {title}
                </Text>
            </Flex>
            {children}
        </Stack>
    );
};

export default TopCompanyInfoWrapper;
